type OtherSpace = {
	code: string;
	name: string;
};

const otherTypes: OtherSpace[] = [
	{
		code: "sanctionedPlan",
		name: "Sanctioned Plan",
	},
	{
		code: "occupancyCertificate",
		name: "OC",
	},
	{
		code: "encumbranceCertificateService",
		name: "EC",
	},
	{
		code: "dcConversion",
		name: "DC Conversion",
	},
	{ code: "saleDeed", name: "Sale Deed" },
	{
		code: "rentalAgreement",
		name: "Rental Agreement",
	},
];

export { otherTypes, type OtherSpace };
